var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", [
    _c("caption", [_vm._v("Consignment Summary")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v(_vm._s(_vm.consignmentNote))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.consigned))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.reference))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.sender))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.receiver))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.eta))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Connote")]),
        _vm._v(" "),
        _c("th", [_vm._v("Consigned")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reference")]),
        _vm._v(" "),
        _c("th", [_vm._v("Sender")]),
        _vm._v(" "),
        _c("th", [_vm._v("Receiver")]),
        _vm._v(" "),
        _c("th", [_vm._v("ETA")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }